"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isStringMatch = void 0;
var getVal_1 = require("./getterSetterDeleter/getVal");
var toArray_1 = require("./toArray");
var isStringMatch = function (_a) {
    var data = _a.data, toMatchPath = _a.toMatchPath, // can be array or string
    subString = _a.subString, 
    // string, subString, strValPathObj = null
    _b = _a.matchType // alt startsWith
    , 
    // string, subString, strValPathObj = null
    matchType = _b === void 0 ? 'includes' : _b // alt startsWith
    ;
    var isMatch = false;
    var pathsAry = (0, toArray_1.toArray)(toMatchPath);
    for (var i = 0; i < pathsAry.length; i++) {
        var path = pathsAry[i];
        var stringToMatch = (0, getVal_1.getVal)(data, path);
        if (stringToMatch === null || stringToMatch === void 0 ? void 0 : stringToMatch.toLowerCase()[matchType](subString === null || subString === void 0 ? void 0 : subString.toLowerCase())) {
            isMatch = true;
            break;
        }
    }
    return isMatch;
};
exports.isStringMatch = isStringMatch;
